const OBJECT_GRAPH_NODE_TYPE = 'O' as const;
const OBJECT_TYPE_GRAPH_NODE_TYPE = 'T' as const;

export const GRAPH_NODE_TYPES = Object.freeze({
	OBJECT: OBJECT_GRAPH_NODE_TYPE,
	OBJECT_TYPE: OBJECT_TYPE_GRAPH_NODE_TYPE,
});

type ObjectGraphNode = {
	type: typeof OBJECT_GRAPH_NODE_TYPE;
	nodeId: string;
	referenceId: string;
};

export type ObjectTypeGraphNode = {
	type: typeof OBJECT_TYPE_GRAPH_NODE_TYPE;
	nodeId: string;
	referenceId: string;
	objectSchemaId: string;
	name: string;
	icon: string;
};

export type GraphNode = ObjectGraphNode | ObjectTypeGraphNode;
